"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const hoistNonReactStatic = require("hoist-non-react-statics");
const context_1 = require("./context");
function useTrans(WrapperComponent) {
    class WithTransPageComponent extends React.Component {
        render() {
            const { gettext, localeObj } = this.context;
            return (React.createElement(WrapperComponent, Object.assign({}, this.props, { gettext: gettext, localeObj: localeObj })));
        }
    }
    WithTransPageComponent.contextType = context_1.I18NContext;
    return hoistNonReactStatic(WithTransPageComponent, WrapperComponent);
}
exports.useTrans = useTrans;
//# sourceMappingURL=useTrans.js.map